import { sha1 } from "./syncKey";

// Where the two sides of a matching step sit on screen (primitives contract
// §5.1). Authors describe relationships; this decides the presentation.
//
// Each side is shuffled on its own, from a seed made of the attempt's id, the
// step's id and the side. The same attempt therefore always gets the same
// arrangement, across rerenders, revisits and refreshes, without storing
// anything; a new attempt has a new id and so may get a new arrangement.
// Nothing here affects what is right: pairs are still checked by item value.

const seedOf = (text) => {
  const hash = sha1(new TextEncoder().encode(text));
  return ((hash[0] << 24) | (hash[1] << 16) | (hash[2] << 8) | hash[3]) >>> 0;
};

// mulberry32: small, fast and good enough to arrange a handful of cards.
const randomFrom = (seed) => {
  let a = seed;
  return () => {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
};

const shuffled = (items, seed) => {
  const random = randomFrom(seed);
  const out = [...items];
  for (let i = out.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
};

// True when every picture sits directly opposite its own partner.
export const isStraightAcross = (left, right, pairs) =>
  left.length > 1 &&
  left.every((item, row) =>
    pairs.some((p) => p.left === item.value && p.right === right[row]?.value)
  );

// { left, right }: the step's items in the order they are shown.
export const matchingLayout = (step, attemptId) => {
  const base = `${attemptId}:${step.id}`;
  const left = shuffled(step.left, seedOf(`${base}:left`));
  let right = shuffled(step.right, seedOf(`${base}:right`));
  // Moving the partners along by one row puts every one of them opposite a
  // different picture, because each picture has exactly one partner.
  if (isStraightAcross(left, right, step.expectedPairs)) {
    right = [...right.slice(1), right[0]];
  }
  return { left, right };
};
